import script from "./PharmacyBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./PharmacyBilling.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__